function generateYears() {
  const currentYear = (new Date()).getFullYear();
  const yearsList = [];
  for (let i = 2011; i <= currentYear; i++) {
    yearsList.push(i);
  }

  return yearsList;
}

function getCurrentMonthIndex() {
  // January === 0
  // February === 1 etc..
  return (new Date()).getMonth();
}

export const YEARS = generateYears();
export const YEARS_FROM_LATEST = YEARS.slice().reverse();
export const MONTHS = [
  {
    name: 'January',
    number: '01',
  },
  {
    name: 'February',
    number: '02',
  },
  {
    name: 'March',
    number: '03',
  },
  {
    name: 'April',
    number: '04',
  },
  {
    name: 'May',
    number: '05',
  },
  {
    name: 'June',
    number: '06',
  },
  {
    name: 'July',
    number: '07',
  },
  {
    name: 'August',
    number: '08',
  },
  {
    name: 'September',
    number: '09',
  },
  {
    name: 'October',
    number: '10',
  },
  {
    name: 'November',
    number: '11',
  },
  {
    name: 'December',
    number: '12',
  },
];
export const MONTHS_FROM_LATEST = MONTHS.slice().reverse();
export const MONTHS_IN_CURRENT_YEAR_FROM_LATEST = MONTHS.slice(0, getCurrentMonthIndex() + 1).reverse();
